import { render, staticRenderFns } from "./rulebased.vue?vue&type=template&id=e6f97c48&"
import script from "./rulebased.vue?vue&type=script&lang=js&"
export * from "./rulebased.vue?vue&type=script&lang=js&"
import style0 from "./rulebased.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports